import type { ReportEntriesParams, ReportRequestBody } from '@query'
import { ENTRY_PANEL_PAGE_SIZE } from './entryPanelConstants'

type DrillScope = { account_number: string } | { document_number: string }

/**
 * Drill panels still receive the report request body they were built from. The
 * dedicated entries endpoint only needs the window and the tag filter, both of
 * which the body's first column already carries.
 */
export const drillEntryParams = (
  reportBody: ReportRequestBody,
  scope: DrillScope,
  page: number
): ReportEntriesParams => {
  const column = reportBody.columns?.[0]
  const dateFrom = column && 'date_from' in column ? column.date_from : undefined
  const dateTo = !column ? undefined : 'date_to' in column ? column.date_to : column.date_at

  return {
    ...scope,
    date_from: dateFrom,
    date_to: dateTo,
    tag_ids: reportBody.tag_ids?.length ? reportBody.tag_ids : undefined,
    page,
    page_size: ENTRY_PANEL_PAGE_SIZE
  }
}
